<template>
  <div id="app">
    <keep-alive include="nickname,compileaddress">
      <router-view v-if="isRouterAlive" />
    </keep-alive>
  </div>
</template>

<script>
// 当页面加载完成后触发该函数
    window.onload = function () {

        // e.preventDefault()  ===    阻止默认事件

        // 当一个手指放在屏幕上时，会触发 touchstart 事件。如 果另一个手指又放在了屏幕上，则会先触发 gesturestart 事件
        document.addEventListener('gesturestart', function (e) {
            e.preventDefault();
        });

        // 在单个元素上单击两次 ===  dblclick
        document.addEventListener('dblclick', function (e) {
            e.preventDefault();
        });

        // 一个手指放在屏幕上时，会触发 touchstart 事件
        document.addEventListener('touchstart', function (event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        });

        // 如果一个或两个手指在屏幕上滑动，将会触发 gesturechange 事件。
        // 但只要有一个手指移开， 就会触发 gestureend 事件，紧接着又会触发基于该手指的 touchend 事件。
        var lastTouchEnd = 0;
        document.addEventListener('touchend', function (event) {
            var now = (new Date()).getTime();
            // 如果在300ms内触发两次touchend，就阻止默认事件
            if (now - lastTouchEnd <= 300) {
                event.preventDefault();
            }
            lastTouchEnd = now;
        }, false);
    };

/* (function(d){
  const html = d.getElementsByTagName('html')[0];  // html节点
  let resizeEvent = 'orientationchange' in window ? 'orientationchange' : 'resize';
  function getScale() {
    let width = html.clientWidth, // 设备宽度
        dpr = window.devicePixelRatio, // 像素比
        scale = Number(width/750).toFixed(4),  //  320：0.427   768：1.024
        // lastScale = scale>1.024?1.024:(scale<0.427?0.427:scale);

        //设置大小
        lastScale = scale>0.160?0.160:(scale<0.120?0.120:scale);
    return lastScale;
  }
  let changePage = function(e) {
    let lastScale = getScale();
    if ( html.clientWidth <= 768 ) {
      html.setAttribute('style','font-size:'+(lastScale*100).toFixed(3)+'px');
    } else {
      html.setAttribute('style','')
    }
  }
  changePage();
  if (!document.addEventListener) return;
  window.addEventListener(resizeEvent, changePage, false);  // 监听设备屏幕旋转/页面resize
  document.addEventListener('DOMContentLoaded', changePage, false); // 监听刷新页面
})(document); */




/* (function(doc, win) {
var docEl = doc.documentElement, resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize', recalc = function() {
var clientWidth = docEl.clientWidth;
if (!clientWidth)
return;
docEl.style.fontSize = 32 * (clientWidth / 750) + 'px';
docEl.getElementsByTagName("body")[0].style.fontSize = docEl.style.fontSize;
};

if (!doc.addEventListener)
return;
win.addEventListener(resizeEvt, recalc, false);
doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window); */


export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="less">
@import "./assets/common/font/font.css";
html,body,#app{
  width: 100%;
  height: 100%;
  // font-family: 'PingFang'; 
}
</style>
